import Vue from 'vue'
import moment from 'moment'

Vue.filter('mutateJPSimpleDate', function(value){
  moment.locale('ja');
  return moment(value).format('YYYY/MM/DD LT');
});

Vue.filter('mutateJPFullWidthOnlyDate', function(value){
  moment.locale('ja');

  const convertFullWidth = function(string){
    string = string + '';

    return string.replace(/./g, s => {
      return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
    })
  };

  const dateSet = {
    year    : moment(value).format('YYYY'),
    month   : moment(value).format('MM'),
    day     : moment(value).format('DD'),
  };

  dateSet.year    = convertFullWidth(dateSet.year);
  dateSet.month   = convertFullWidth(dateSet.month);
  dateSet.day     = convertFullWidth(dateSet.day);

  return dateSet.year+'年'+dateSet.month+'月'+dateSet.day+'日';
});

Vue.filter('mutateJPFullWidthDateTime', function(value){
  moment.locale('ja');

  const convertFullWidth = function(string){
    string = string + '';

    return string.replace(/./g, s => {
      return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
    })
  };

  const dateSet = {
    year    : moment(value).format('YYYY'),
    month   : moment(value).format('MM'),
    day     : moment(value).format('DD'),
    hour    : moment(value).format('HH'),
    minute  : moment(value).format('mm')
  };

  dateSet.year    = convertFullWidth(dateSet.year);
  dateSet.month   = convertFullWidth(dateSet.month);
  dateSet.day     = convertFullWidth(dateSet.day);
  dateSet.hour    = convertFullWidth(dateSet.hour);
  dateSet.minute  = convertFullWidth(dateSet.minute);

  return dateSet.year+'年'+dateSet.month+'月'+dateSet.day+'日'+dateSet.hour+'時'+dateSet.minute+'分';
});

Vue.filter('mutateUnavailableDate', function(value){
  moment.locale('ja');

  const convertFullWidth = function(string){
    string = string + '';

    return string.replace(/./g, s => {
      return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
    })
  };

  const dateSet = {
    year    : moment(value).format('YYYY'),
    month   : moment(value).format('MM'),
    day     : moment(value).format('DD'),
    hour    : moment(value).format('HH')
  };

  dateSet.year    = convertFullWidth(dateSet.year);
  dateSet.month   = convertFullWidth(dateSet.month);
  dateSet.day     = convertFullWidth(dateSet.day);
  dateSet.hour    = convertFullWidth(dateSet.hour);

  return dateSet.year+'年'+dateSet.month+'月'+dateSet.day+'日'+dateSet.hour+'時頃';
});

Vue.filter('mutateFlashLineDate', function(value){
  moment.locale('ja');

  const convertFullWidth = function(string){
    string = string + '';

    return string.replace(/./g, s => {
      return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
    })
  };

  const dateSet = {
    year    : moment(value).format('YYYY'),
    month   : moment(value).format('MM'),
    day     : moment(value).format('DD'),
    hour    : moment(value).format('HH'),
    minute  : moment(value).format('mm')
  };

  dateSet.year    = convertFullWidth(dateSet.year);
  dateSet.month   = convertFullWidth(dateSet.month);
  dateSet.day     = convertFullWidth(dateSet.day);
  dateSet.hour    = convertFullWidth(dateSet.hour);
  dateSet.minute  = convertFullWidth(dateSet.minute);

  return dateSet.year+'年'+dateSet.month+'月'+dateSet.day+'日'+dateSet.hour+'時'+dateSet.minute+'分頃';
});

Vue.filter('mutateJPDate', function(value){
  moment.locale('ja');
  return moment(value, 'YYYY-MM-DD h:mm:ss').format('L');
});

Vue.filter('mutateJPTime', function(value){
  moment.locale('ja');
  return moment(value, 'YYYY-MM-DD h:mm:ss').format('LT');
});

Vue.filter('mutateJPTimeOnly', function(value){
  moment.locale('ja');

  const convertFullWidth = function(string){
    string = string + '';

    return string.replace(/./g, s => {
      return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
    })
  };

  const dateSet = {
    year    : moment(value).format('YYYY'),
    month   : moment(value).format('MM'),
    day     : moment(value).format('DD'),
    hour    : moment(value).format('HH'),
    minute  : moment(value).format('mm')
  };

  dateSet.year    = convertFullWidth(dateSet.year);
  dateSet.month   = convertFullWidth(dateSet.month);
  dateSet.day     = convertFullWidth(dateSet.day);
  dateSet.hour    = convertFullWidth(dateSet.hour);
  dateSet.minute  = convertFullWidth(dateSet.minute);

  if( moment(value).isSame(new Date(), 'day') ){
    return dateSet.hour+'時'+dateSet.minute+'分頃';
  }else{
    return dateSet.month+'月'+dateSet.day+'日';
  }
});

Vue.filter('mutateFullWidth', function(value){
  value = value+"";
  return value.replace(/./g, s => {
    return String.fromCharCode(s.charCodeAt(0) + 0xfee0)
  })
});

Vue.filter('jpSmaryTruncate', function(value, limit = 100, suffix = '...'){
  let count = 0;

  for (let i = 0;  i < value.length; i++) {
    count += value.charCodeAt(i) <= 255 ? 1 : 2;

    if (count > limit) {
      return value.substr(0, i) + suffix;
    }
  }

  return value;
});

Vue.filter('nameTruncate', function(value, limit = 20){
  let count = 0;

  for (let i = 0;  i < value.length; i++) {
    count++;
    // count += value.charCodeAt(i) <= 255 ? 1 : 2;

    if (count > limit) {
      return value.substr(0, i);
    }
  }

  return value;
});

Vue.filter('mutateImageSizeTo250', function(value){
  return value.replace('.png', '_250x250.png');
});

Vue.filter('mutatePathPngToWebp', function(value){
  return value.replace('.png', '.webp');
});

Vue.filter('templateReplacer', function(text, templateSet){
  for(let templateKey in templateSet){
    const regex = new RegExp("\\[\\["+templateKey+"\\]\\]", 'g');

    text = text.replace(regex, templateSet[templateKey]);
  }

  return text;
});